module.exports = __webpack_public_path__ + "static/img/5912_phase_function_Paper_Points.6fa650d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5912_phase_function_Paper_Points.png
// module id = Tghf
// module chunks = 0